import { getAuthToken, getGuestId } from "@/utils/session";

export function getCartRequestParams() {
  const token = getAuthToken();

  return {
    Token: token || "",
    TempUserId: token ? "" : getGuestId(),
  };
}

export function getRemoveCartParams(cartId) {
  return {
    ...getCartRequestParams(),
    CartId: cartId,
  };
}
